import React, { useContext, useState } from "react";
import Message from "./Message";
import Loading from "../../../Loading";
import { StaffContext } from "../../../../../Context";
import useDBO from "../../../hooks/useDBO";
import Lang from "../../../components/Lang";
import { Bell, Plus, Sparkles } from "lucide-react";
import NewMessageDialog from "../../../../topbar/components/NewMessageDialog";


export default function Messages() {
  const { staff } = useContext(StaffContext);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const messagesData = useDBO("/home-messages");

  // Filter messages to show only real data from the server
  const displayMessages = (messagesData.get && messagesData.get.length > 0) 
    ? messagesData.get 
    : [];

  if (!staff) return <Loading />;

  return (
    <div className="home-widget messages-widget flex flex-col h-full bg-white border border-slate-200 rounded-[24px] shadow-sm overflow-hidden">
      <div className="px-6 pt-6 pb-4 border-b border-slate-100 flex justify-between items-center bg-slate-50">
        <h3 className="font-heading text-[1.25rem] font-semibold text-slate-900 flex items-center gap-2">
          <Bell size={22} className={`text-teal-800`} />
          <Lang w="messages"/>
        </h3>
        <button
          className="bg-white hover:bg-slate-50 text-slate-700 font-bold py-1.5 px-4 rounded-xl text-xs border border-slate-200 shadow-sm transition-all active:scale-95 cursor-pointer flex items-center gap-2"
          onClick={() => setIsDialogOpen(true)}
        >
          <Plus size={14} />
          <Lang w="newMessage" />
        </button>
      </div>

      <div className="flex-1 overflow-y-auto p-5 bg-white">
        {displayMessages.length > 0 ? (
          <div className="flex flex-col gap-5">
            {displayMessages.map((message) => (
              <Message
                key={message._id}
                message={message}
                removeMessage={messagesData.remove}
                staff={staff}
                messages={messagesData}
              />
            ))}
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center h-full text-center text-slate-400 py-10">
            <Sparkles size={36} className="mb-3 opacity-30" />
            <p className="text-sm font-medium"><Lang w="allCaughtUp" /></p>
          </div>
        )}
      </div>

      <NewMessageDialog 
        messageDialogOpen={isDialogOpen} 
        setMessageDialogOpen={setIsDialogOpen} 
        description="" 
      />
    </div>
  );
}

